import * as React from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from '../Common/Actions';
import $ from 'jquery';
import { Field, reduxForm, change, onChange,submit,getFormValues } from 'redux-form';
import Loading from '../Common/Loading';
import Utils from '../Common/Utils';
import Chart,{ Radar } from 'react-chartjs-2';
import '../../templates/common/radio_btn.scss';
//import { relative } from 'path';
//import * as jsPDF from 'jspdf';
//import * as html2canvas from 'html2canvas';
//import * as rasterizeHTML from 'rasterizehtml';
import ModalForm from '../Common/ModalForm';
import Auth from '../Common/Auth';
import * as DataManager from '../Common/DataManager';
import * as ActionAdmin from '../Common/ActionAdmin';
//import { push } from 'connected-react-router';
import moment from 'moment';
import HtmlElement, { renderDescription } from '../Common/HtmlElement';
//window.html2canvas = html2canvas;
//window.rasterizeHTML = rasterizeHTML;

class Step4 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: Auth.GetUser(), page: {}, current_datetime: false, Request_Chindate: false, project_Info: false, action_btn: false,
            frmeror: null, isEmail: true, onBody: props.onBody, //isEmail: props.isEmail,
            loading: true, onRef: props.onRef, values: props.initialValues, xdata: false, GuestData: props.GuestData, Analysis: null, bg_img: {},person_id:false,
            chart_options:{
                data: {
                        labels: this.getLabel(),
                        backgroundColor: "rgba(220,220,220,0.2)",
                        pointBackgroundColor: "rgba(220,220,220,1)",
                        datasets: [{
                            label: 'Pecentage',                            
                            borderWidth: 2,
                            fill: true,
                            borderColor: 'rgba(0,119,204, 0.5)',
                            pointBackgroundColor: this.getColors(),
                            pointHighlightStroke: this.getColors(),
                            pointRadius:5,
                            data: this.getData()
                        }]
                    },
                options: {                   
                    spanGaps: true,
                    responsive: true,
                    maintainAspectRatio: true,
                    tooltips: {
                        filter: function (tooltipItem) {
                            return tooltipItem.datasetIndex === 0;
                        }
                    },
                    scale: {
                        reverse: false,
                        ticks: {
                            display: true,
                            min: 0,
                            maxTicksLimit: 5,
                            stepSize: 33,
                            max: 100,                            
                            callback: function (value) {
                                return (value == 66 ? 67 : value) + "%"
                            }
                        },
                        scaleLabel: {
                            display: true,
                            /*fontSize: 20,*/
                            fontStyle: 'bold',
                            fontColor: '#000',
                            //align: 'center',
                            fontStyle:'bold'
                        },
                        pointLabels: {
                            fontSize: this.getFontSize(),
                            //fontColor: 'blue',
                            align: 'end',
                            textAlign: 'end',
                            fullWidth: true,
                            fillStyle: { color: 'red' },
                            callback: function (val, e) {
                                return val;
                            }
                        },
                        gridLines: {
                            display: true,
                            lineWidth: 2,
                            color:'rgb(139,0,0,0.1)'
                        },
                    },
                    gridLines: {
                        display: false,
                    },
                    legend: {
                        display: false
                    }
                    //legendCallback: function (chart) {
                    //    // Return the HTML string here.
                    //    console.log(chart.data.datasets);
                    //    var text = [];
                    //    text.push('<ul class="' + chart.id + '-legend">');
                    //    for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
                    //        text.push('<li><span id="legend-' + i + '-item" style="background-color:' + chart.data.datasets[0].backgroundColor[i] + '"   onclick="updateDataset(event, ' + '\'' + i + '\'' + ')">');
                    //        if (chart.data.labels[i]) {
                    //            text.push(chart.data.labels[i]);
                    //        }
                    //        text.push('</span></li>');
                    //    }
                    //    text.push('</ul>');
                    //    return text.join("");
                    //},
                }
            }            
        }
        this.labels = false;
        this.cancelProc = this.cancelProc.bind(this);
        this.submitMail = (val) => {            
            this.setState({ frmeror: null });
            if (!val || !val.email) {
                this.setState({ frmeror: 'กรุณาระบุที่อยู่อีเมล์' });
                return;
            }            
            if (!this.state.GuestData || !this.state.GuestData.person_Info) {
                this.setState({ frmeror: 'ไม่สามารถส่งอีเมล์ได้ #1 กรุณาลองใหม่อีกครั้ง' });
                return;
            }            
            window.$("#common-modal-form").modal('hide');
            this.setState({ loading: true });
            let req_data = this.getRenderData();
            req_data['email'] = val.email;

            let model_name = "MailProfileReport";
            ActionAdmin.Report(model_name, req_data, true, this.genFileName()).then(xdata => {
                if (xdata && xdata.status === 200) {
                    alert('ส่งข้อมูลสำเร็จ กรุณาดูข้อความในอีเมล์');
                } else {
                    //this.setState({ frmeror: 'ไม่สามารถส่งอีเมล์ได้ #2 กรุณาลองใหม่อีกครั้ง' });
                    //console.log(xdata);
                    alert('ไม่สามารถส่งอีเมล์ได้ #2 กรุณาลองใหม่อีกครั้ง');
                }
            }).then(x => { this.setState({ loading: false });});

            //Actions.SentMail({ id: this.state.GuestData.person_Info.id, email: val.email }).then(data => {                
            //    if (data.status === 200) {
            //        alert('ส่งข้อมูลสำเร็จ กรุณาดูข้อความในอีเมล์');
            //    } else {
            //        this.setState({ frmeror: 'ไม่สามารถส่งอีเมล์ได้ #2 กรุณาลองใหม่อีกครั้ง' });
            //        alert(this.state.frmeror);
            //    }
            //    this.setState({ loading: false });
            //});            
        }
        //this.watermark = () => {
        //    window.$('.watermark-chart').width($('#render-chart').width() + 30).height($('#render-chart').height() + 15);
        //}

    }

    getFontSize() {
        if ($(window).width() < 980) {
            return 12;
        } else
            return 14;
    }

    getRenderData = () => {
        let chart = document.getElementById("profile_chart");
        if (!chart) {
            alert('Chart not found'); return;
        }
        let id;
        if (this.state.GuestData && this.state.GuestData.person_Info) {
            id = this.state.GuestData.person_Info.id;
        } else if (this.state.GuestData && this.state.GuestData.Person_Info) {
            id = this.state.GuestData.Person_Info.id;
        }
        let img;
        if (chart.toDataURL && typeof chart.toDataURL === "function")
            img = chart.toDataURL("image/png");
        else
            img = chart.src;
        return {
            body: img, id: id,
            name: $('#profile_name').html(), group: $('#profile_group').html(), gender: $('#profile_gender').html(),
            dob: $('#profile_dob').html(), place: $('#profile_place').html(), element: $('#profile_element').html(),
            factor1: $('#profile_factor1').html(), factor2: $('#profile_factor2').html(),
            analysys: $('#profile_analysys').html(), recommend: $('#profile_recommend').html(),
            type: $('#profile_type').html(), table_element: $('#table_element').html()
        };
    }

    genFileName() {
        let file_name = 'ProfileReport_' + DataManager.Guid() + '.pdf';
        const user = this.props.GuestData && this.props.GuestData.users ? this.props.GuestData.users : (this.props.GuestData && this.props.GuestData.Users ? this.props.GuestData.Users : null);
        //console.log(user);
        if (user && user.packageInfo) {
            const xname = Utils.toFileName($('#profile_name').text()) + '_' + Utils.toFileName($('#profile_group').text()) + '_' + Utils.toFileName($('#profile_type').text()) + '_' + moment(new Date()).format('YYYYMMDD-HHmmss');
            if (user.packageInfo.projectInfo && user.packageInfo.projectInfo.project_type === 'Project') {
                file_name = user.packageInfo.projectInfo.code + '_' + xname + '.pdf';
            } else if (user.packageInfo.promo_Code) {
                file_name = user.packageInfo.promo_Code.code + '_' + xname + '.pdf';
            }
        }
        return file_name;
    }

    savePdf = () => {
        this.setState({ loading: true });
        let model_name = "ProfileReport";
        let file_name = this.genFileName();
        //console.log(file_name);
        //return;
        ActionAdmin.Report(model_name, this.getRenderData()).then(xdata => {
            if (xdata) {
                let url = window.URL.createObjectURL(xdata);
                let a = document.createElement('a');
                a.href = url;
                a.download = file_name;
                a.click();
            }
        }).then(x => { this.setState({ loading: false }); });


        //const input = document.getElementById('card_body');
        //html2canvas(input)
        //    .then((canvas) => {
        //        const imgData = canvas.toDataURL('image/png');
        //        var imgWidth = 210;
        //        var pageHeight = 295;
        //        var imgHeight = canvas.height * imgWidth / canvas.width;
        //        var heightLeft = imgHeight;
        //        var doc = new jsPDF('p', 'mm');
        //        var position = 0;

        //        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        //        heightLeft -= pageHeight;

        //        while (heightLeft >= 0) {
        //            position = heightLeft - imgHeight;
        //            doc.addPage();
        //            doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        //            heightLeft -= pageHeight;
        //        }
        //        doc.save("FASTEn_saved.pdf");
        //        //var a = document.createElement('a');
        //        //a.href = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
        //        //a.download = 'somefilename.jpg';
        //        //a.click();

        //        this.setState({ loading: false });
        //    });
    };

    renderEmailFrm() {
        return <div className="form-group row">
            <label className="col-sm-3 text-right control-label col-form-label">E-mail:</label>
            <div className="col-sm-9">
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text" id="input-email"><i className="fa fa-envelope"></i></span>
                    </div>
                    <Field className="form-control" name="email" placeholder="" component="input" type="email" aria-describedby="input-email" required/>
                </div>
            </div>
        </div>;
    }

    openFrm() {
        if (this.state.onBody)
            window.$("#common-modal-form").appendTo("body").modal({ show: true });
        else
            window.$("#common-modal-form").modal({ show: true });
    }

    submitMail(val) {
        this.submitMail(val);
    }

    renderCanvas(gdata) {
        let user = gdata.users ? gdata.users : (gdata.Users ? gdata.Users : null);
        if (user && (user.packageInfo.packageConfig.show_chart == false && user.packageInfo.packageConfig.show_character == false)) {
            var c = document.getElementById("profile_chart");
            var ctx = c.getContext("2d");
            ctx.font = "16px Arial"
            ctx.textBaseline = "middle";
            ctx.fillText("Not available for this package", 150, 250); 


        }
    }

    renderChart(gdata) {
        let data = this.state.chart_options.data;
        let user = gdata.users ? gdata.users : (gdata.Users ? gdata.Users : null);        
        if (user && (user.packageInfo.packageConfig.show_chart == false && user.packageInfo.packageConfig.show_character == false)) {
            return <img id="profile_chart" src="data:image/png;base64,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" style={{ width:'100%' }} />;
        }
        ////console.log(this.state.chart_options.data.labels);
        //if (data.labels && data.labels.length === 5) {
        //    let bg = [];
        //    let br = [];
        //    for (var elm in data.labels) {
        //        bg.push(this.getColor(this.state.chart_options.data.labels[elm], true));
        //        br.push(this.getColor(this.state.chart_options.data.labels[elm]));
        //    }
        //    data.backgroundColor = bg;
        //    data.borderColor = br;
        //    //console.log(data.backgroundColor);
        //}

        //this.state.values.unknow_place
        const img = <img id="profile_chart" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0CAIAAABEtEjdAAAACXBIWXMAAAsTAAALEwEAmpwYAAAK0WlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDggNzkuMTY0MDM2LCAyMDE5LzA4LzEzLTAxOjA2OjU3ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnBob3Rvc2hvcD0iaHR0cDovL25zLmFkb2JlLmNvbS9waG90b3Nob3AvMS4wLyIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDIwLTA3LTE1VDAyOjE0OjU3KzA3OjAwIiB4bXA6TWV0YWRhdGFEYXRlPSIyMDIwLTEyLTAyVDAzOjE0OjAzKzA3OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMC0xMi0wMlQwMzoxNDowMyswNzowMCIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyIgcGhvdG9zaG9wOklDQ1Byb2ZpbGU9InNSR0IgSUVDNjE5NjYtMi4xIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyMWYzYzEzZi1lNThjLTc1NDYtYjI0NS0wYjM1Y2E5YzEyY2IiIHhtcE1NOkRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDozNDMzYmEyOC0zYjJkLWNhNDYtOWQ1Yy0xODFlYzFjM2ExOTMiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpCM0Q4MjQ0RTA2QzZFQTExQTc2MUM2M0ExQTc1ODlGNiI+IDxwaG90b3Nob3A6VGV4dExheWVycz4gPHJkZjpCYWc+IDxyZGY6bGkgcGhvdG9zaG9wOkxheWVyTmFtZT0iTm90IGF2YWlsYWJsZSBmb3IgdGhpcyBwYWNrYWdlIiBwaG90b3Nob3A6TGF5ZXJUZXh0PSJOb3QgYXZhaWxhYmxlIGZvciB0aGlzIHBhY2thZ2UiLz4gPHJkZjpsaSBwaG90b3Nob3A6TGF5ZXJOYW1lPSJOb3QgYXZhaWxhYmxlIFRpbWUgb2YgQmlydGggYW5kIFBsYWNlIG9mIEJpcnRoIGFyZSByZXF1aXJlZCIgcGhvdG9zaG9wOkxheWVyVGV4dD0iTm90IGF2YWlsYWJsZSBUaW1lIG9mIEJpcnRoIGFuZCBQbGFjZSBvZiBCaXJ0aCBhcmUgcmVxdWlyZWQiLz4gPC9yZGY6QmFnPiA8L3Bob3Rvc2hvcDpUZXh0TGF5ZXJzPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjcmVhdGVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOkIzRDgyNDRFMDZDNkVBMTFBNzYxQzYzQTFBNzU4OUY2IiBzdEV2dDp3aGVuPSIyMDIwLTA3LTE1VDAyOjE0OjU3KzA3OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ1M2IChXaW5kb3dzKSIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6ZTMxMTRmNWYtMDQwOS0yZTQxLTk4ZGYtMDFhYWQ5ODVhYTIyIiBzdEV2dDp3aGVuPSIyMDIwLTEyLTAyVDAzOjEyOjI1KzA3OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgMjEuMCAoV2luZG93cykiIHN0RXZ0OmNoYW5nZWQ9Ii8iLz4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjQ4OGY0MWRjLTAxMDctMjY0Zi04YmRkLTk2ZWFhNTE2ZWQ3OSIgc3RFdnQ6d2hlbj0iMjAyMC0xMi0wMlQwMzoxNDowMyswNzowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKFdpbmRvd3MpIiBzdEV2dDpjaGFuZ2VkPSIvIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjb252ZXJ0ZWQiIHN0RXZ0OnBhcmFtZXRlcnM9ImZyb20gYXBwbGljYXRpb24vdm5kLmFkb2JlLnBob3Rvc2hvcCB0byBpbWFnZS9wbmciLz4gPHJkZjpsaSBzdEV2dDphY3Rpb249ImRlcml2ZWQiIHN0RXZ0OnBhcmFtZXRlcnM9ImNvbnZlcnRlZCBmcm9tIGFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5waG90b3Nob3AgdG8gaW1hZ2UvcG5nIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJzYXZlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDoyMWYzYzEzZi1lNThjLTc1NDYtYjI0NS0wYjM1Y2E5YzEyY2IiIHN0RXZ0OndoZW49IjIwMjAtMTItMDJUMDM6MTQ6MDMrMDc6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMS4wIChXaW5kb3dzKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDg4ZjQxZGMtMDEwNy0yNjRmLThiZGQtOTZlYWE1MTZlZDc5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkIzRDgyNDRFMDZDNkVBMTFBNzYxQzYzQTFBNzU4OUY2IiBzdFJlZjpvcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6QjNEODI0NEUwNkM2RUExMUE3NjFDNjNBMUE3NTg5RjYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4u14BZAAAU2ElEQVR4nO3dT2icef3A8Wd+/G6p7mEhOYiX1J1QxASRvXSFwsSl2Za9LCZMxIPQFAMtShuoLG5yaFdEIblowWp6k7ZmILdig9tADy0FcSUjIpuaXHYFE1B2NXMeD1/6ZXYmmaZpkm0/+3qd5t/zzDOT9j2TZybPp9RsNgsAYvm/z3oDANh/4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLgDBCTuAAGJO0BA4g4QkLhDcf369VKpdP369XT2/PnzpVLp/PnzT1ywVCqVSqVarbaHa+FAiTv7b25uLnVtbm6u9fLh4eFdRvOQTUxMFEVx48aNz3pDYN+IOwdoamqqXq/vbdkHDx7Mzc0NDw/v7yZta35+viiKycnJQ7gvOBzizsG6cOFCo9HYw4IPHz6cmpra9+3Z1pkzZ5rN5ujo6OHcHRwCceegVCqVSqWyvLx869atnW5Tq9XSvppSqTQ+Pv7gwYN0+fDwcCr78vJy5+6doijq9frMzEzpsbm5ufQSknaXz8zM5FsODAykHd+bm5tp33py/vz59fX1dJvuO9m7LNj6QPK1m5ubXR5vXo998RysJuy32dnZ9K9rZWUlnVhbW2s2m5VKpSiKc+fOpZtNT093/oNcWFjIt8xmZ2fb7mJhYaFtwXSbO3fupLNbW1vNZvP+/fv5bN6YrFKppLWdO3eudcPaznZZMJ/tcm16RNs+3vn5+QP5AUCz6Z07B2hwcDCF/uzZs21Xra+vX7lypWgJd0rqO++802g07t69mxZMobx48WLb4qOjo/kfcYrmtWvXiqL45je/mW6Qivzw4cOiKKanp3t6egYHB/Mi6bVheXm58z34to/iiQtubGw0H7+qbbva/Hjv3LnTfPyCMTExsbd9VvBE4s7B+v73v592zrTthXj06FE68d3vfjed+M53vlMUxerq6sbGxhNXW6/Xx8fH0/6NFM3V1dWiKHp6elLr01v4VPyRkZGiKDY3N/OenLGxsbSera2tJ97XExecnJzs7e0tiuJb3/pW26PL/vSnP6UTIyMjpVJpaGgond3Ng4U9EHcOVk9PT4pvzuKzazQaQ0NDeVd+2+6OlPLf/e539Xp9dXW1XC4fP368KIof/vCHaUs6F+luDwt+4Qtf2OXKd/PqAnsg7hy448eP5/0V+cJXXnklnfjtb3+bTvziF78oiqJcLvf39+ebffTRR507LtbW1tKJtGO97dqhoaFyuby6uvrTn/60KIpLly6ly9OLwf3795vN5te+9rXO7fzb3/627dknLri4uJg28te//nXehnzthx9+WBTFl770pXQ27ZbJBgcHO1cI++DA9ubz+ZU/UM2XbG1tlcvldGH3D1Rz+1o/Mm37QLVtV0Zec+cGFEWxsrKSLmz92DMvkq5t3ZI7d+60ne2y4Lb/p/LW5hsXRbGxsVGtVttumT9rhX0n7uy/zrg3W764kuPebDYXFhZyAavVanp3nGxtbeXIdn5bJn8rZnZ2Nr8MdN5X/uJKs9lcWVnJX9fJi6dGb2xs5ILfv3+/7WyXBdPp+fn5vKmtX4Bp/ZpN+iUj/bVU3rb8wgP7rtTc4d0HAC8u+9wBAhJ3gIDEHSAgcQcISNwBAhJ3gIDE/QW2tLRUKpW6HGD24DQajXRol6capjE8PNx58N4uNz60mU3pSLxPtchn+OQn6+vr6WjJu39KNzc3S6XS0tLS7m/suMQvLnF/3uXDnbep1+v/+c9/Pqutunbt2vvvv7+xsXH37t22q9q2s7UOH3300eFu5rNKgcsGBgaen9idPXu2t7e32XHIzHq93rrNw8PDueaOY/O5Iu7Pu7t376a/N0t/9pn//GxwcDAd9jYdj/CQ3b59+/XXX9/prvMflC4sLIyNjeW4fPDBB50H783S4I4D2dxnk4+IcOnSpbGxseeh75ubm8vLy2+99dZON8jbfOzYsZGRkfQbRn9/f7PZPHny5LaLNBqNgYGBXb6v5/kn7hyg0dHRcrn817/+dTc3TgfYep6dOXOmWq0uLi5+1hvyFNKr6Z///Ocn3rLRaKTDJhODuL/AWnf7ptN5at3AwEC9Xl9aWkpD5trekS0tLeW9PTMzMzvNi6jVamnxNAMvDaBIv/UvLy9fvXr1iftkUy9eeumldLZ1n3vapZ7m283NzZVKpampqTRUr/X9e7qqdQM6tc7AywP20h6Vubm5dBdtU/Q2Nzfz5ePj47t/XXn11Ve33c++7Ta0PYTW/d27mbfXaDRal80/qVqt1tfXVxTF2NhY2kHXZYP/+c9/Fo8PQdy6zz0/P+mzk7zOdLj5vJ0ffvhh6xNotMiL5JCOYcMza9st03x88Kw0AyidrlQqGxsbW1tb1Wq1XC5XKpU03y6dbZ08l45HuLa2VqlUOg/L1Xx8iKv0231eYbqvZrNZqVRaj//Vqvj0cKW0SXmpfFU6FFfrYRFnZ2dbj/OVbpBuv7a2Vi6Xt73HdLTFdASu9CSkdeYjR6aH0HrV1tZWpVKpVqtpwzqPO9a68uLTB+mtVqtpM1qf/J22IT/z+ar0cObn5/NRw9Lt244DnJfNP8H0k6pWq60btu1BJdPRytIK04bl56314eTnJx+8rO3BdnkCeSGI+wtjN3HPR1VMwcr/FVPQ03/jtpqniKfuZ53tSJ/F5UMedo97q9ajJLbFvVwutz3Atri3nk3b2e0JajabzWa5XE53kR5C6yNt63LrERnTMR0719bWu3SzVNvWJ3+nbei8o851pg3L1c46l00/xPQjfmLcs0qlkm/WGffp6emdNqzLE8gLwW6ZUI4cOZJOfPGLXyyKYmBgoO3y9EHc1NRU/mV/YmKiKIq2X7fTLtq8eFEUPT09lUplN7tui5YirKys3LhxY3x8fNubvf76693Xc+zYsXw6PaJtd4nUarW5ubm0o6ltr/GXv/zlfPrll19O8zfSl3Zap2RsO4IjS3sqSqXSo0ePVlZWWmeJdN+G9GFD2ziO9BzmdZZKpVu3bnU+rs5lv/KVrxRF8Y9//KPLpma50ZOTk2NjY9evX9/2Zt0feLHDE8gLQdw/jzrf8R3QV24GBwcnJydv3bq1mznUe3P9+vU0wO83v/lN89MTOXbyySeftF3S/UulOZQ3b97cdnDSHrah7e185zdK98vo6Oj09PTPf/7zA1o/zy1x/3zp7e0tl8v37t3rfrM0A++DDz7IlzQajeXl5RMnThzs9j29GzduzM7OXrx4sb+/v9Fo7Oar9OndaOvrzS5/I3nabUh31PaBZ+dz22UjW5f9+9//Xnz61ynoQtxfYOkrEOnrELv37rvvXr16NX9rZWZmpvPbGv39/dPT0/kr6o1GY2JiolKpnDp16qnuq16v/+pXv6pWq2lXRm9vb5e38C+99NLy8vLT/s1nb2/v7du3026lH/3oR7v5Mt+JEyfK5fKPf/zjdF9zc3NXr159qjstPv3k77QNp06dqlQqFy5cSI96aWlpbm6uv7//3Llz+bnd3NwcHx/v/MZL27Lr6+vT09PT09NPO3O1VqtduXIlDZLt6ekpdv41JV27y++t8vwT9xfY8ePHz507NzQ0tPs/QC+KYnR0dGFhIe92//e///2Nb3yj82aXL1+en59Pu4aPHDny8ssv37x5M/3/f6K88qGhodOnT+fZcm+//Xb6AuW2BX/zzTcrlUpfX99T/SnTT37yk6Iojhw5UiqVvv71r+9ml0hvb296Pevr6yuVSh9//HHr9LtdGhoaqlar6cnfaRt6enpu3rx57Nixo0ePlkqlH/zgB1/96leLovjZz342PT2dntu+vr5XX3316NGjbetPy7722mtp2aNHj54+ffry5cu73Ly8T/+dd95ZWFg4c+ZMWmf6s7Jtn+F0bfrZ+VOmAIzZAwjIO3eAgMQdICBxBwhI3AECEneAgMQdICBxh+091VC6LvYwww+enbjD9gyl44X2/5/1BsBzKg2l+6y3AvbIO3eAgMSdw5OnAKbhdvkIM20j94qiWF9fT+PfugzYSyPo0h7tdLCURqMxMzOTlhoeHm7dXd46MjCNxEuHl0lTA1uP25VnAXYZSpcu3Gla4Z5n+ME+EncOz+Li4uTkZLPZXFtbe//993/5y1/mq65evXrixIlms3nx4sXNzc033njjlVdeaT6eAHX27Nmd1nnv3r18PPSJiYlHjx6l6UinT58eGRlJrx+1Wm1sbOzdd99tNpsbGxvvvffe3rZ/amrq7bffbjabJ0+efPDgwcjISH449+/fv3btWlEUjUZjfHz8X//6V9qMt956a2pqam93B89k32c7wW5MT0/nKXptI/fa5u21jpdrleYOpqF3zY65d61zAduGAq6trRWPJ5akoXStozPyLMDuQ+l2mla4+xl+cKB8oMrhqdfr77333h//+Mdbt24VRdF6eN7WkXu3b99eXl5u+/rgf//7323XmYfepQOR9/X1tV77ySefpDEjk5OTnYs8rTyULk0rTAMLW2+QJ3XsfoYfHBC7ZTgkDx48GBoa+vjjj7/3ve81H7/v3knnIOaTJ0/u5l7alrp48WLbeNiiY2Dsnm07rfBpZ/jBARF3DsnDhw8rlcrly5dTpruMZHrttdf+8Ic/PG2Ct51pVzyeLPiXv/wlX5J2yyRpdHgeepfe5j/xvrpMK9z3GX6wN+LOIUlT9FL1arVal8l23/72t1dXVycmJlLfa7Xa+fPnn7j+U6dOlcvlPJeuXq/neUOXLl26cuVK+nrM+vr6hQsX8lL9/f3lcnlxcTEPyctXdR9Kt9O0wn2Z4QfPTtw5JNVqtVqtpqFx9+7dSx8zbmtwcPDOnTubm5tpcN3i4uKbb775xPX39PT8/ve/7+3tTXcxOjqa97OfOXNmdnZ2bGysVCq98cYbaaBoVqvV8n21DcnrMpRup2mF+zLDD56dMXt8HpVKpYWFhdHR0c96Q+CgeOcOEJC4AwQk7gAB2ecOEJB37gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQOIOEJC4AwQk7gABiTtAQP8DjUJu6y76pmIAAAAASUVORK5CYII=" style={{ width: '100%' }} />;
        if (!this.state.loading && this.props.GuestData.data_Model && this.props.GuestData.data_Model.forecast) {
            //if (this.props.GuestData.unknow_time)
            let person_info = this.props.GuestData.person_Info ? this.props.GuestData.person_Info : (this.props.GuestData.Person_Info ? this.props.GuestData.Person_Info : null)
            if(person_info && person_info.unknow_time)
                return img;
            return <Radar id="profile_chart" data={data} options={this.state.chart_options.options} className="radar-chart" height={100} width={100} />
        } else {
            if (this.state.values && this.state.values.unknow_time)
                return img;
            return <Radar id="profile_chart" data={data} options={this.state.chart_options.options} className="radar-chart" height={100} width={100} />
        }
    }

    getLabel(){
        if (!this.props.GuestData.data_Model || !this.props.GuestData.data_Model.forecast || !this.props.GuestData.data_Model.forecast.figures)
            return ['Finance', 'Authority', 'Support', 'Teamwork', 'Engagement'];
        
        let data = this.props.GuestData;  
        //return [
        //    data.data_Model.forecast.figures.finance.replace(/\(()/gi, ',(').replace("Finance", "F").split(','),
        //    data.data_Model.forecast.figures.authority.replace(/\(()/gi, ',(').replace("Authority", "A").split(','),
        //    data.data_Model.forecast.figures.support.replace(/\(()/gi, ',(').replace("Support", "S").split(','),
        //    data.data_Model.forecast.figures.teamwork.replace(/\(()/gi, ',(').replace("Teamwork", "T").split(','),
        //    data.data_Model.forecast.figures.engagement.replace(/\(()/gi, ',(').replace("Engagement", "En").split(',')
        //];

        


        let user = data.users ? data.users : (data.Users ? data.Users : null);

        let f = data.data_Model.forecast.figures.finance.split('\n');//.replace("Finance", "F");        
        let a = data.data_Model.forecast.figures.authority.split('\n');//.replace("Authority", "A");
        let s = data.data_Model.forecast.figures.support.split('\n');//.replace("Support", "S");
        let t = data.data_Model.forecast.figures.teamwork.split('\n');//.replace("Teamwork", "T");
        let en = data.data_Model.forecast.figures.engagement.split('\n');//.replace("Engagement", "En");
        if (user && user.packageInfo.packageConfig.show_character == true) {
            f = DataManager.checkNotNull(data.data_Model.sub_F) ? [...f,data.data_Model.sub_F] : f; //data.data_Model.forecast.figures.finance.replace("Finance", "F")
            a = DataManager.checkNotNull(data.data_Model.sub_A) ? [...a,data.data_Model.sub_A] : a; // data.data_Model.forecast.figures.authority.replace("Authority", "A");
            s = DataManager.checkNotNull(data.data_Model.sub_S) ? [...s,data.data_Model.sub_S] : s;    //data.data_Model.forecast.figures.support.replace("Support", "S");
            t = DataManager.checkNotNull(data.data_Model.sub_T) ? [...t,data.data_Model.sub_T] : t;  // data.data_Model.forecast.figures.teamwork.replace("Teamwork", "T");
            en = DataManager.checkNotNull(data.data_Model.sub_En) ? [...en,data.data_Model.sub_En] : en; // data.data_Model.forecast.figures.engagement.replace("Engagement", "En");
        }
        f = f.filter(function (el) {
            return (el != null && el != '');
        });
        a = a.filter(function (el) {
            return (el != null && el != '');
        });
        s = s.filter(function (el) {
            return (el != null && el != '');
        });
        t = t.filter(function (el) {
            return (el != null && el != '');
        });
        en = en.filter(function (el) {
            return (el != null && el != '');
        });        
        this.labels = [f, a, s, t, en];
        //let chart_labels = [f, a, s, t, en];
        //f = null; a = null; s = null; t = null; en = null;
        if ($(window).width() < 980) {
            f = DataManager.removeArrayByIndex(f, 1);
            a = DataManager.removeArrayByIndex(a, 1);
            s = DataManager.removeArrayByIndex(s, 1);
            t = DataManager.removeArrayByIndex(t, 1);
            en = DataManager.removeArrayByIndex(en, 1);
            f[0] = 'F';
            a[0] = 'A';
            s[0] = 'S';
            t[0] = 'T';
            en[0] = 'En';      
        }

        return [f, a, s, t, en];
    }

    getColor(elm,is_bg = false) {
        if (!elm || elm === '' || typeof elm[1] === 'undefined') return 'rgba(10, 10, 10, 0.2)';        
        if (is_bg) {
            let bg = { 'Water': 'rgba(17,103,177, 0.2)', 'Wood': 'rgba(0,128,0, 0.2)', 'Fire': 'rgba(255,0,0, 0.2)', 'Earth': 'rgba(165,42,42, 0.2)', 'Metal': 'rgba(192,192,192, 0.2)' };
            return bg[elm[1].replace(/[()]/g, '')];
        }else {
            let br = { 'Water': 'rgba(17,103,177, 1)', 'Wood': 'rgba(0,128,0, 1)', 'Fire': 'rgba(255,0,0, 1)', 'Earth': 'rgba(165,42,42, 1)', 'Metal': 'rgba(192,192,192, 1)' };
            return br[elm[1].replace(/[()]/g, '')];
        }
    }

    getColors(is_bg = false) {
        let colors = [];
        //console.log(this.labels);
        if (this.labels && this.labels.length === 5) {            
            for (var elm in this.labels) {
                colors.push(this.getColor(this.labels[elm], is_bg));
            }
            return colors;
        }
        if (is_bg) return [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)'];
        else return [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)'];
    }
    getData() {
        if (!this.props.GuestData.data_Model || !this.props.GuestData.data_Model.forecast)
            return [0,0,0,0,0];
        let data = this.props.GuestData;
        return [
            data.data_Model.forecast.f,
            data.data_Model.forecast.a,
            data.data_Model.forecast.s,
            data.data_Model.forecast.t,
            data.data_Model.forecast.en
        ];
    }

    

    componentDidMount() {
        // const xIndex = this.props.xIndex || 0;        
        $('#render-table').html('loading...');
        if (this.state.GuestData.person_Info && this.state.GuestData.person_Info.id) {
            sessionStorage.setItem('personxi', this.state.GuestData.person_Info.id);
        } else if (this.state.GuestData.Person_Info && this.state.GuestData.Person_Info.id) {
            sessionStorage.setItem('personxi', this.state.GuestData.Person_Info.id);
        }
        Actions.Get_Step(sessionStorage.getItem('personxi'), 2,false).then(xdata => {
            this.setState({
                Request_Chindate: xdata.data.request_Chindate,
                //maine: xdata.data.request_Chindate.chindate_Objects.find(x => x.type === 'Element')
            });
        });

        if (this.props.GuestData.data_Model && this.props.GuestData.data_Model.forecast) {
            Actions.Get_Analysis(this.props.GuestData.data_Model.forecast.id).then(data => {
                if (data.status === 200) {
                    this.setState({
                        Analysis: data.data,
                        loading: false
                    });
                }
            }).then((x) => this.setState({ loading: false }));
        }else
            this.setState({
                loading: false
        });

        if (!Auth.IsAdmin(this.state.user) && !Auth.IsProjectAdmin(this.state.user)) {
            ActionAdmin.Get(ActionAdmin.Models.Pro, { type: 'last' }).then(xdata => {
                if (xdata && xdata.status === 200 && xdata.data) {
                    this.setState({
                        page: xdata.data
                    });
                } else {
                    this.setState({
                        page: {}
                    });
                }
            });
            if (this.state.user.packageInfo && this.state.user.packageInfo.projectInfo && this.state.user.packageInfo.projectInfo.project_type === 'Project')
                this.setState({action_btn:true});
        }
        let current_datetime = new Date();
        let formatted_date = current_datetime.getDate() + "/" + (current_datetime.getMonth() + 1) + "/" + current_datetime.getFullYear() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes();
        this.setState({ current_datetime: formatted_date });
        //$(window).on('resize', function () {
        //    window.watermarkSize('.watermark-chart',$('#render-chart').width() + 30, $('#render-chart').height()+15);
        //});
        //console.log('W:' + $(window).width());
        //console.log(this.state.GuestData);
    }

    watermark() {
        window.$('.watermark-chart').width($('#render-chart').width() + 30).height($('#render-chart').height()+15);
    }
    isUnknowPlace() {
        if (typeof this.state.values.unknow_place != 'undefined')
            return this.state.values.unknow_place;
        else if (this.state.values.person_Info && typeof this.state.values.person_Info.unknow_place != 'undefined')
            return this.state.values.person_Info.unknow_place;
        else if (this.state.values.Person_Info && typeof this.state.values.Person_Info.unknow_place != 'undefined')
            return this.state.values.Person_Info.unknow_place;
        else if (this.state.GuestData && this.state.GuestData.person_Info && typeof this.state.GuestData.person_Info.unknow_place != 'undefined')
            return this.state.GuestData.person_Info.unknow_place;
        else if (this.state.GuestData && this.state.GuestData.Person_Info && typeof this.state.GuestData.Person_Info.unknow_place != 'undefined')
            return this.state.GuestData.Person_Info.unknow_place;
        else
            return false;
    }
    renderPlace(state) {
        if (this.isUnknowPlace())
            return <div className="basic-txt" id="profile_place"><b>สถานที่เกิด/Place of Birth: </b> -</div>;
        else
            return <div className="basic-txt" id="profile_place"><b>สถานที่เกิด/Place of Birth: </b> {this.state.values.district && this.state.values.district.value ? this.state.values.district.label + ', ' : ''}
                {this.state.values.province ? this.state.values.province.label + ', ' : ''}
                {this.state.values.country ? this.state.values.country.label : ''}</div>
    }
    cancelProc() {
        sessionStorage.removeItem('personxi');
        this.props.onCancelProc(1);
    }
    renderPage(state) {
        if (!state.page || !state.page.name) return <></>;
        return <div className="card-body">
            <div className="row">
            <div className="col-md">
                    <div className="padding-left-30 header-info"><h2 className="text-secondry">{state.page.name}</h2></div>
                <div className="consent-info-text" dangerouslySetInnerHTML={{ __html: state.page.description }} />
            </div>
        </div>
            <hr />
        </div>;
    }
    logout() {
        this.props.history.push('/logout');
    }
//    <span className="margin-5">
//    <button type="button" onClick={() => { if (window.confirm('คุณต้องการเริ่มต้นข้อมูลใหม่ ใช่หรือไม่?')) { this.cancelProc(); } }} className="btn btn-primary btn-lg"><i className="fa fa-fast-backward" aria-hidden="true"></i> New</button>
//</span>
    renderBtn(state) {
        if (state.action_btn === true) {
            return <div className="form-group btn-center text-center">                
                <span className="margin-5">
                    <button type="button" onClick={this.savePdf} className="btn btn-dark btn-lg"><i className="fa fa-download text-success" aria-hidden="true"></i> Download</button>
                </span>
                {state.isEmail ? <span className="margin-5"><button type="button" onClick={() => this.openFrm()} className="btn btn-dark btn-lg margin-left-10"><i className="fa fa-envelope" aria-hidden="true"></i> E-mail</button></span> : ''}
                <span className="margin-5">
                    <Link to="/logout" onClick={(e) => { if (window.confirm('คุณต้องการออกจากระบบ ใช่หรือไม่?')) { return true } else { e.preventDefault(); return false } }} className="btn btn-success btn-lg"><i className="fa fa-times" aria-hidden="true"></i> Logout</Link>
                </span>
            </div>
        } else {
            return <div className="form-group btn-center text-center">
                <span className="margin-5">
                    <button type="button" onClick={this.savePdf} className="btn btn-dark btn-lg"><i className="fa fa-download text-success" aria-hidden="true"></i> Download</button>
                </span>
                {state.isEmail ? <span className="margin-5"><button type="button" onClick={() => this.openFrm()} className="btn btn-dark btn-lg margin-left-10"><i className="fa fa-envelope" aria-hidden="true"></i> E-mail</button></span> : ''}
            </div>
        }
    }

    //---- 2020-06-15
//    <div className="txt-border-white">
//    <div className="basic-txt"><img src="/img/hero/logo.png" className="foot-logo" /></div>
//    <div className="basic-txt"><b>Name:</b> {this.state.values.first_name} {this.state.values.last_name}</div>
//    <div className="basic-txt"><b>Gender:</b> <span className="first-upper">{this.state.values.gender}</span></div>
//    <div className="basic-txt"><b>Birth:</b> {this.state.values.date_of_birth.replace(/\/.*\//, '/xx/').split(' ')[0]} xx:xx</div>
//    <div className="basic-txt" > < b > Place: </b> {this.state.values.district && this.state.values.district.value ? this.state.values.district.label + ', ' : ''}
//        {this.state.values.province ? this.state.values.province.label + ', ' : ''}
//        {this.state.values.country ? this.state.values.country.label : ''}</div >
//    <div className="basic-txt"><b>Main Element:</b> <span className="text-secondary">{this.state.GuestData.data_Model ? this.state.GuestData.data_Model.forecast.du : '-'}</span></div>
//</div>
    //-----

    //<span className="bg-topr" style={{backgroundImage:'url('+(this.state.GuestData && this.state.GuestData.data_Model ? '/img/icons/Element/'+this.state.GuestData.data_Model.forecast.du+'.png?v=1' : '/img/icons/empty.png?v=1')+')'}}></span>
    render() {
        const { handleSubmit, onChange } = this.props;
        //this.watermark();
        //$(window).on('resize', function () {
        //    window.watermarkSize('.watermark-chart', $('#render-chart').width() + 30, $('#render-chart').height()+15);
        //});
        //{ this.state.values.date_of_birth } {/* this.state.values.birth_time */ }
        //{this.state.values.date_of_birth.replace(/^.{3}/g, 'xx/').split(' ')[0]}
        //console.log(this.state.values);
        return (<>
            <form className="form-horizontal" id="form_body" onSubmit={handleSubmit}><Loading loading={this.state.loading} />
                <div className="card-body" id="card_body">                    
                    <div className="padding-2"></div>
                    <div className="row" id="data_body">     
                        <div className="col-sm-6">
                            <div className="header-info text-center">FASTEn Model&trade;</div>                            
                            <div className="relative-elm">
                                <div className="watermark-chart">&nbsp;</div>
                                <div id="render-chart" className="chart-container">
                                    {this.renderChart(this.props.GuestData)}
                                </div>
                                </div>
                            <div className="padding-10 text-center">
                                Print date: {this.state.current_datetime}
                            </div>
                            <div className="header-info">Your Birth Chart</div>
                            <div className="relative-elm">
                                <div className="watermark-table">&nbsp;</div>
                                <table id="table-info" className="table table-bordered table-active text-center table-elm">
                                    <thead>
                                        <tr>
                                            <th scope="col" className="text-danger">Hour</th>
                                            <th scope="col">Day</th>
                                            <th scope="col" className="text-danger">Month</th>
                                            <th scope="col">Year</th>
                                        </tr>
                                    </thead>
                                    {this.state.loading ? <tbody id="table_element"><tr><td colSpan="4"><p>Loading...</p></td></tr></tbody> : renderDataTable(this.state)}
                                </table>
                            </div>
                        </div>
                        <div className="col-sm-6 main-content">
                            <div className="txt-border-white">
                                <div className="basic-txt"><img src="/img/hero/logo.png" className="foot-logo" /></div>                                
                                <div className="basic-txt" id="profile_name"><b>ชื่อ/Short Name:</b> {this.state.values.first_name}</div>
                                <div className="basic-txt" id="profile_group"><b>หมายเลขอ้างอิง/Reference Code:</b> {DataManager.checkNotNull(this.state.values.last_name) ? this.state.values.last_name : '-'}</div>                                
                                <div className="basic-txt" id="profile_gender"><b>เพศ/Gender:</b> <span className="first-upper">{this.state.values.gender}</span></div>
                                <div className="basic-txt" id="profile_dob"><b>วว/ดด/ปปปป เกิด, DD/MM/YYYY of Birth:</b> {this.state.values.date_of_birth.replace(/\/.*\//, '/xx/').split(' ')[0]} xx:xx</div>
                                {this.renderPlace(this.state)}
                                <div className="basic-txt" id="profile_element"><b>Main Element:</b> <span className="text-secondary">{this.state.GuestData.data_Model ? this.state.GuestData.data_Model.forecast.du : '-'}</span></div>
                                <div className="basic-txt" id="profile_type"><b>Type:</b> <span className="text-secondary">{this.state.values.unknow_time ? '-' :  (this.state.GuestData.data_Model ? this.state.GuestData.data_Model.forecast.type : '-')}</span></div>
                            </div>



                            <div style={{ paddingTop:'7px' }}>
                                <div className="header-info-sm header-info-line">
                                    <i className="fa text-success pr-1"><svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-check-circle mb-1" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" /><path fillRule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" /></svg></i>3 ปัจจัยแรกในการเลือกงาน / Top 3 factors in selecting a job</div>
                                {renderHighfactors(this.state.Analysis, this.props.GuestData)}
                            </div>                            
                            <div>
                                <div className="header-info-sm header-info-line">
                                    <i className="fa text-success pr-1"><svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-check-circle mb-1" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path fillRule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/></svg></i>2 ปัจจัยสุดท้ายในการเลือกงาน / Last 2 factors in selecting a job</div>
                                {renderLowfactors(this.state.Analysis, this.props.GuestData)}
                            </div>
                            <div className="padding-5"></div>
                            <div>
                                <div className="header-info-sm header-info-line">
                                    <i className="fa text-success pr-1"><svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-check-circle mb-1" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path fillRule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/></svg></i>บทวิเคราะห์ / Analysis</div>
                                <div id="profile_analysys">{this.state.values.unknow_time ? <>-</> : renderAnalysis(this.state.Analysis, this.props.GuestData)}</div>
                            </div>
                            <div>
                                <div className="header-info-sm header-info-line">
                                    <i className="fa text-success pr-1"><svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-check-circle mb-1" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" /><path fillRule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" /></svg></i>คำแนะนำเพื่อเพิ่มความสมดุลในการทำงานร่วมกับผู้อื่น / Recommendations to improve the balance when working with others</div>
                                {this.state.values.unknow_time ? <div id="profile_recommend">-</div> : renderRecommend(this.state.Analysis, this.props.GuestData)}
                            </div>
                        </div>                        
                    </div>                    
                </div>
                <div className="border-top">
                    <div className="card-body">
                        {this.renderBtn(this.state)}
                    </div>
                </div>
                {this.renderPage(this.state)}
            </form>
            
            <ModalForm form="Form_Modal" xerror={this.state.frmeror} btnName="ส่งข้อมูล" body={this.renderEmailFrm()} title={`ส่งอีเมล์/Send e-mail`} onSubmit={this.submitMail} />
              </> );
    }
}
//<i className="fa fa-check-circle text-success" aria-hidden="true"></i>
//initialValues={}
function renderScoreTable(props){
    if (props.GuestData.data_Model && props.GuestData.data_Model.forecast && props.GuestData.data_Model.forecast.figures){
        const data = props.GuestData;
        return (<table className="table table-sm table-bordered text-center">
                <thead>
                    <tr>
                        <th scope="col">{data.data_Model.forecast.figures.finance}</th>
                        <th scope="col">{data.data_Model.forecast.figures.authority}</th>
                        <th scope="col">{data.data_Model.forecast.figures.support}</th>
                        <th scope="col">{data.data_Model.forecast.figures.teamwork}</th>
                        <th scope="col">{data.data_Model.forecast.figures.engagement}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{data.data_Model.forecast.f}%</td>
                        <td>{data.data_Model.forecast.a}%</td>
                        <td>{data.data_Model.forecast.s}%</td>
                        <td>{data.data_Model.forecast.t}%</td>
                        <td>{data.data_Model.forecast.en}%</td>
                    </tr>
                </tbody>
            </table>);
    }else{
        return <></>;
    }

}

const numb_w = { width:'16px',display:'inline-block'};
const desc_numb = 16;


function renderHighfactors(props,data) {
    let user = data.users ? data.users : (data.Users ? data.Users : null);
    if (user && user.packageInfo.packageConfig.show_factor == true) {
        if (props && props.rankingState && props.rankingState.length > 1) {
            let i = 0;
            return (<div id="profile_factor1">
                {props.rankingState.map((data) => {
                    i++;
                    if (i > 3) { return null }
                    return <div style={{paddingBottom: '3px'}} key={i+'hfactors' + data.id}><span style={numb_w}>{i})</span>{renderDescription(data, desc_numb)}</div>;
                })}
            </div>);
        } else {
            return <div style={{paddingBottom: '3px'}} id="profile_factor1"><p>Not found data</p></div>;
        }
    }else
        return <div style={{paddingBottom: '3px'}} id="profile_factor1"><p>Not available for this package</p></div>;
}

function renderLowfactors(props, data) {
    let user = data.users ? data.users : (data.Users ? data.Users : null);
    if (user && user.packageInfo.packageConfig.show_factor == true) {
        if (props && props.rankingState && props.rankingState.length === 5) {        
            return (<div id="profile_factor2">
                <div style={{paddingBottom: '3px'}} key="lfactors4"><span style={numb_w}>4)</span>{renderDescription(props.rankingState[3], desc_numb)}</div>
                <div style={{paddingBottom: '3px'}} key="lfactors5"><span style={numb_w}>5)</span>{renderDescription(props.rankingState[4], desc_numb)}</div>
            </div>);
        } else {
            return <div style={{paddingBottom: '3px'}} id="profile_factor2"><p>Not found data</p></div>;
            }
    } else
        return <div style={{paddingBottom: '3px'}} id="profile_factor2"><p>Not available for this package</p></div>;
}

function renderAnalysis(props, data) {
    let user = data.users ? data.users : (data.Users ? data.Users : null);
    if (user && user.packageInfo.packageConfig.show_analysis == true) {
        if (props && props.fasten_Model && props.fasten_Model.description_th) {
            return <div style={{paddingBottom: '3px'}} className="basic-txt">{renderDescription(props.fasten_Model)}</div>;
        } else {
            return <div style={{paddingBottom: '3px'}} ><p>Not found data</p></div>;
        }
    } else
        return <div style={{paddingBottom: '3px'}} ><p>Not available for this package</p></div>;
}

function renderRecommend(props,data) {
    let user = data.users ? data.users : (data.Users ? data.Users : null);
    if (user && user.packageInfo.packageConfig.show_recommendation == true) {
        if (props && props.recommend && props.recommend.length > 1) {
            let i = 0;
            return (<div id="profile_recommend">
                {props.recommend.map((data) => {
                    i++;
                    return <div style={{ paddingBottom: '6px' }} key={i+'hfactors' + data.id}><span style={{ width: '9px', display: 'inline-block', fontWeight: "bold", color:"#25394c" }}>-</span>{renderDescription(data, 9)}</div>;
                })}
            </div>);
        } else {
            return <div id="profile_recommend"><p>Not found data</p></div>;
        }
    } else
        return <div id="profile_recommend"><p>Not available for this package</p></div>;
}

function renderElements(state, step) {
    if (state.user && state.user.packageInfo && state.user.packageInfo.packageConfig && state.user.packageInfo.packageConfig.show_elements) {
        if (state.user.packageInfo.packageConfig.show_elements === 8) return true;
        if (!state.user.packageInfo.packageConfig.configElements || state.user.packageInfo.packageConfig.configElements == '')
            return false;
        let conf = state.user.packageInfo.packageConfig.configElements;
        return conf.indexOf(step) >= 0;
    } else if (state.GuestData && state.GuestData.users && state.GuestData.users.packageInfo && state.GuestData.users.packageInfo.packageConfig && state.GuestData.users.packageInfo.packageConfig.show_elements) {
        if (state.GuestData.users.packageInfo.packageConfig.show_elements === 8) return true;
        if (!state.GuestData.users.packageInfo.packageConfig.configElements || state.GuestData.users.packageInfo.packageConfig.configElements == '')
            return false;
        let conf = state.GuestData.users.packageInfo.packageConfig.configElements;
        return conf.indexOf(step) >= 0;
    }else
        return false;
}

function renderDataTable(props) {
    const type = ['Element', 'Year'];
    const host = window.location.protocol +'//'+window.location.host;
    if (props && props.Request_Chindate && props.Request_Chindate.chindate_Objects) {
        return (<tbody id="table_element">
            {props.Request_Chindate.chindate_Objects.map((data, i) => {
                let is_type = type.indexOf(data.type) >= 0;
                if (is_type) {
                    return <tr key={data.id + 'x' + i}>
                        <td key={'xtd1'+i} className="table-border text-danger">{is_type ? (renderElements(props, data.type === 'Element' ? 'hu' : 'hl') ? <img src={`${host}/img/icons/${data.type}/${data.bd_hour}.png?v=1`} className="elm-img" /> : <img src={`${host}/img/icons/empty.png`} className="elm-img" />) : data.bd_hour}</td>
                        <td key={'xtd2'+i} className="table-border">{is_type ? (renderElements(props, data.type === 'Element' ? 'du' : 'dl') ? <img src={`${host}/img/icons/${data.type}/${data.bd_day}.png?v=1`} className="elm-img" /> : <img src={`${host}/img/icons/empty.png`} className="elm-img" />) : data.bd_day}</td>
                        <td key={'xtd3'+i} className="table-border text-danger">{is_type ? (renderElements(props, data.type === 'Element' ? 'mu' : 'ml') ? <img src={`${host}/img/icons/${data.type}/${data.bd_month}.png?v=1`} className="elm-img" /> : <img src={`${host}/img/icons/empty.png`} className="elm-img" />) : data.bd_month}</td>
                        <td key={'xtd4'+i} className="table-border">{is_type ? (renderElements(props, data.type === 'Element' ? 'yu' : 'yl') ? <img src={`${host}/img/icons/${data.type}/${data.bd_year}.png?v=1`} className="elm-img" /> : <img src={`${host}/img/icons/empty.png`} className="elm-img" />) : data.bd_year}</td>
                    </tr>
                } else
                    return <></>;
            })}
        </tbody>);
    } else {
        return (<tbody id="table_element">
            <tr>
                <th colSpan="4"><p>Not found</p></th>
            </tr>
        </tbody>);
    }

}


Step4 = reduxForm({
    form: 'Step_4'
})(Step4);
Step4 = connect(
   (state, props) => ({
       state: { values: props.values, GuestData: props.GuestData},
       initialValues: props && props.values ? props.values : { start: false },
       GuestData: props.GuestData
   })
)(Step4);
export default Step4;